import {BaseCard, BasePagination, BaseTable} from "@/components";
import type {Column} from "@/components/BaseTable/BaseTable";
import {useAuditLogs} from "@/hooks/useAuditLog";
import type {AuditLogEntry} from "@/services/audit-log.service";
import {useState} from "react";

export function AuditLog() {
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [entityType, setEntityType] = useState("");
  const [action, setAction] = useState("");

  const filters: Record<string, string | number> = {page, limit};
  if (entityType) filters.entityType = entityType;
  if (action) filters.action = action;

  const {data, isLoading} = useAuditLogs(filters);
  const items = data?.items ?? [];
  const pagination = data?.pagination ?? {total: 0, page: 1, limit: 20, totalPages: 1};

  const columns: Column<AuditLogEntry>[] = [
    {key: "entityType", header: "Entidad"},
    {key: "entityId", header: "ID Entidad", render: row => row.entityId.slice(0, 8)},
    {key: "action", header: "Acción"},
    {key: "systemUserId", header: "Admin", render: row => (row.systemUserId ? row.systemUserId.slice(0, 8) : "-")},
    {key: "ip", header: "IP", render: row => row.ip ?? "-"},
    {key: "createdAt", header: "Fecha", render: row => new Date(row.createdAt).toLocaleString()},
  ];

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold text-(--color-text-primary)">Audit Log</h1>
        <p className="text-sm text-(--color-text-secondary) mt-1">Registro de auditoría del sistema</p>
      </div>

      <div className="flex gap-3 items-end">
        <div className="flex flex-col gap-1">
          <label className="text-xs text-(--color-text-secondary)">Entidad</label>
          <input
            type="text"
            placeholder="e.g. user, freeze"
            value={entityType}
            onChange={e => {
              setEntityType(e.target.value);
              setPage(1);
            }}
            className="border border-(--color-border) bg-(--color-bg-secondary) rounded-lg px-3 py-1.5 text-sm w-40"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-(--color-text-secondary)">Acción</label>
          <input
            type="text"
            placeholder="e.g. create, update"
            value={action}
            onChange={e => {
              setAction(e.target.value);
              setPage(1);
            }}
            className="border border-(--color-border) bg-(--color-bg-secondary) rounded-lg px-3 py-1.5 text-sm w-40"
          />
        </div>
      </div>

      <BaseCard padding="none">
        <BaseTable<AuditLogEntry>
          data={items}
          columns={columns}
          loading={isLoading}
          emptyMessage="No hay registros"
        />
        {pagination.totalPages > 1 && (
          <BasePagination
            page={page}
            totalPages={pagination.totalPages}
            total={pagination.total}
            limit={limit}
            onPageChange={setPage}
          />
        )}
      </BaseCard>
    </div>
  );
}
